var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"Error404_wrap"}},[_c('div',{staticClass:"text-center text-danger mt-5"},[_c('h4',[_vm._v("Page is Missing....")])])])
}]

export { render, staticRenderFns }